export const TRACKING_TABLES = {
    HYPERPURE_CLICKS: "hyperpure_clicks",
    HYPERPURE_IMPRESSION: "hp_app_tracking",
};

export const TRACKING_ACTIONS = {
    ACTION_TYPE_CLICK: "click",
    ACTION_TYPE_UPDATE: "update",
    ACTION_TYPE_IMPRESSION: "IMPRESSION",
};
